// reducers/operatorProfileReducer.js

export const initialProfileState = {
  operatorProfileView: null,
  loadingOpProfile: true,
  opProfileError: '',
  //set active tab
  activeTab: 'sharedsafari',
  //operator share safari
  opSharedSafari: [],
  summary: {},
  pageIndex: 1,
  opSharedSafariLoading: true,
  opSharedSafariError: '',
  //operator share safari
  opPackage: [],
  summaryOp: {},
  pageIndexOp: 1,
  opPackageLoading: true,
  opPackageError: '',
  //operator Parks
  opParks: [],
  summaryParks: {},
  pageIndexParks: 1,
  opParkasLoading: true,
  opParksError: '',
  //operator Review
  opReviews: [],
  summaryReviews: {},
  pageIndexReviews: 1,
  opReviewLoading: true,
  opReviewsError: '',
  //review Filters
  filters: {},

  //opertaor account setting
  operatorAccData: null,
  opAccLoading: true,
  opAccError: '',
  toggleForm: false,
  activeTabOp: 'profile-settings'
};

export const operatorProfileReducer = (state = initialProfileState, action) => {
  switch (action.type) {
    // Operator Account Setting
    case 'SET_OPERATOR_ACCOUNT_SETTING_DATA':
      return {
        ...state,
        operatorAccData: action.payload && typeof action.payload === 'object'
          ? action.payload
          : state.operatorAccData,
      };
    case "SET_OPERATOR_ACCOUNT_LOADING":
      return {
        ...state,
        opAccLoading: typeof action.payload === "boolean" ? action.payload : state.opAccLoading,
      };
    case "SET_OPERATOR_ACCOUNT_ERROR":
      return {
        ...state,
        opAccError: typeof action.payload === "boolean" ? action.payload : state.opAccError,
      };

    case "SET_ACTIVE_TAB_OPERATOR":
      return {
        ...state,
        activeTabOp: typeof action.payload === "string" ? action.payload : state.activeTabOp,
      };

    case "SET_OP_ACC_FORM_TOGGLE":
      return {
        ...state,
        toggleForm: typeof action.payload === "boolean" ? action.payload : state.toggleForm,
      };



    case 'SET_OP_PROFILE_DATA':
      return {
        ...state,
        operatorProfileView:
          action.payload && typeof action.payload === 'object'
            ? action.payload
            : state.operatorProfileView,
      };

    case 'SET_OP_PROFILE_DATA_LOADING':
      return {
        ...state,
        loadingOpProfile:
          typeof action.payload === 'boolean'
            ? action.payload
            : state.loadingOpProfile,
      };

    case 'SET_OP_PROFILE_DATA_ERROR':
      return {
        ...state,
        opProfileError:
          typeof action.payload === 'string'
            ? action.payload
            : state.opProfileError,
      };

    case 'SET_PROFILE_ACTIVE_TAB':
      return {
        ...state,
        activeTab:
          typeof action.payload === 'string' && action.payload.trim().length > 0
            ? action.payload
            : "",
      };
    //operator Shared Safari
    case 'SET_OPERATOR_SHARED_SAFARI_DATA':
      return {
        ...state,
        opSharedSafari: Array.isArray(action.payload)
          ? action.payload
          : state.opSharedSafari,
      };
    case 'APPEND_OPERATOR_SHARED_SAFARI_DATA':
      return {
        ...state,
        opSharedSafari: [
          ...state.opSharedSafari,
          ...action.payload.filter(
            newItem => !state.opSharedSafari.some(existing => existing.id === newItem.id)
          ),
        ],
      };
    case 'SHARED_OPERATOR_SHARED_SAFARI_SUMMARY':
      return {
        ...state,
        summary: action.payload && typeof action.payload === 'object'
          ? action.payload
          : state.summary,
      };
    case 'SET_OPERATOR_SF_DATA_LOADING':

      return {
        ...state,
        opSharedSafariLoading:
          typeof action.payload === 'boolean'
            ? action.payload
            : state.opSharedSafariLoading,
      };
    case 'SET_OPERATOR_SF_DATA_ERROR':
      return {
        ...state,
        opSharedSafariError:
          typeof action.payload === 'string'
            ? action.payload
            : state.opSharedSafariError,
      };
    case 'SET_OPERATOR_SHARED_SAFARI_PAGE_INDEX':
      return {
        ...state,
        pageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
          ? action.payload
          : state.pageIndex,
      };

    //operator Package
    case 'SET_OPERATOR_PACKAGE_DATA':
      return {
        ...state,
        opPackage: Array.isArray(action.payload)
          ? action.payload
          : state.opPackage,
      };
    case 'APPEND_OPERATOR_PACKAGE_DATA':
      return {
        ...state,
        opPackage: [
          ...state.opPackage,
          ...action.payload.filter(
            newItem => !state.opPackage.some(existing => existing.slug === newItem.slug)
          ),
        ],
      };
    case 'SHARED_OPERATOR_PACKAGE_SUMMARY':
      return {
        ...state,
        summaryOp: action.payload && typeof action.payload === 'object'
          ? action.payload
          : state.summaryOp,
      };
    case 'SET_OPERATOR_PAC_DATA_LOADING':
      return {
        ...state,
        opPackageLoading:
          typeof action.payload === 'boolean'
            ? action.payload
            : state.opPackageLoading,
      };
    case 'SET_OPERATOR_PAC_DATA_ERROR':
      return {
        ...state,
        opPackageError:
          typeof action.payload === 'string'
            ? action.payload
            : state.opPackageError,
      };
    case 'SET_OPERATOR_PACKAGE_PAGE_INDEX':
      return {
        ...state,
        pageIndexOp: typeof action.payload === 'number' && !isNaN(action.payload)
          ? action.payload
          : state.pageIndexOp,
      };

    //operator Parks
    case 'SET_OPERATOR_PARK_DATA':
      return {
        ...state,
        opParks: Array.isArray(action.payload)
          ? action.payload
          : state.opParks,
      };
    case 'APPEND_OPERATOR_PARK_DATA':
      return {
        ...state,
        opParks: [
          ...state.opParks,
          ...action.payload.filter(
            newItem => !state.opParks.some(existing => existing.slug === newItem.slug)
          ),
        ],
      };
    case 'SHARED_OPERATOR_PARK_SUMMARY':
      return {
        ...state,
        summaryParks: action.payload && typeof action.payload === 'object'
          ? action.payload
          : state.summaryParks,
      };
    case 'SET_OPERATOR_PARK_DATA_LOADING':
      return {
        ...state,
        opParkasLoading:
          typeof action.payload === 'boolean'
            ? action.payload
            : state.opParkasLoading,
      };
    case 'SET_OPERATOR_PARK_DATA_ERROR':
      return {
        ...state,
        opParksError:
          typeof action.payload === 'string'
            ? action.payload
            : state.opParksError,
      };
    case 'SET_OPERATOR_PARK_PAGE_INDEX':
      return {
        ...state,
        pageIndexParks: typeof action.payload === 'number' && !isNaN(action.payload)
          ? action.payload
          : state.pageIndexParks,
      };
    //operator Review
    case 'SET_OPERATOR_REVIEW_DATA':
      return {
        ...state,
        opReviews: Array.isArray(action.payload)
          ? action.payload
          : state.opReviews,
      };
    case 'APPEND_OPERATOR_REVIEW_DATA':
      return {
        ...state,
        opReviews: [
          ...state.opReviews,
          ...action.payload.filter(
            newItem => !state.opReviews.some(existing => existing.slug === newItem.slug)
          ),
        ],
      };
    case 'SHARED_OPERATOR_REVIEW_SUMMARY':
      return {
        ...state,
        summaryReviews: action.payload && typeof action.payload === 'object'
          ? action.payload
          : state.summaryReviews,
      };
    case 'SET_OPERATOR_REVIEW_DATA_LOADING':
      return {
        ...state,
        opReviewLoading:
          typeof action.payload === 'boolean'
            ? action.payload
            : state.opReviewLoading,
      };
    case 'SET_OPERATOR_REVIEW_DATA_ERROR':
      return {
        ...state,
        opReviewsError:
          typeof action.payload === 'string'
            ? action.payload
            : state.opReviewsError,
      };
    case 'SET_OPERATOR_REVIEW_PAGE_INDEX':
      return {
        ...state,
        pageIndexReviews: typeof action.payload === 'number' && !isNaN(action.payload)
          ? action.payload
          : state.pageIndexReviews,
      };
    // park review filters
    case 'SET_OPERATOR_REVIEW_FILTERS':
      return {
        ...state,
        filters: action.payload && typeof action.payload === 'object'
          ? action.payload
          : state.filters,
      };

    case 'UPDATE_OPERATOR_REVIEW_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
        },
      };


    default:
      return state;
  }
};
